export default __webpack_public_path__ + "static/media/img-index-03-funcionalidades.ed2e248f.png";